export default "__VITE_ASSET__BBjIopBY__"